import { gql } from '@apollo/client';
import { STAFF_DETAIL_FIELDS } from '../../fragments';
import {
  CreateStaffProps,
  GenerateStaffLoginProps,
  RemoveManagerProps,
  TerminateStaffProps,
  UpdateStaffProps,
} from './staff.types';
import { StaffType } from '../../../types';
import { GET_STAFF } from '../../queries';

export const GENERATE_STAFF_LOGIN = gql`
  ${STAFF_DETAIL_FIELDS}
  mutation GenerateStaffLogin($staffId: ID!) {
    generateStaffLogin(staffId:$staffId){
      ...StaffDetailFields
    }
  }
`;

export function generateStaffLogin({ client, staffId }: GenerateStaffLoginProps) {
  return client?.mutate<{ generateStaffLogin: StaffType }>({
    mutation: GENERATE_STAFF_LOGIN,
    variables: {
      staffId,
    },
  });
}

export const CREATE_STAFF = gql`
  ${STAFF_DETAIL_FIELDS}
  mutation CreateStaff(
  $firstName: String!
  $lastName: String!
  $salary: Float!
  $email: String!
  $phone1: String
  $phone2: String
  $addressLine1: String
  $addressLine2: String
  $city: String
  $postalCode: String
  $country: String
  $registrationNumber: String!
  ) {
    createStaff(
    firstName: $firstName
    lastName: $lastName
    salary: $salary
    email: $email
    phone1: $phone1
    phone2: $phone2
    addressLine1: $addressLine1
    addressLine2: $addressLine2
    city: $city
    postalCode: $postalCode
    country: $country
    registrationNumber: $registrationNumber
    ) {
      ...StaffDetailFields
    }
  }
`;

export function createStaff({
  client,
  firstName,
  lastName,
  salary,
  email,
  phone1,
  phone2,
  addressLine1,
  addressLine2,
  city,
  postalCode,
  country,
  registrationNumber,
}: CreateStaffProps) {
  return client?.mutate<{ createStaff: StaffType }>({
    mutation: CREATE_STAFF,
    variables: {
      firstName,
      lastName,
      salary,
      email,
      phone1,
      phone2,
      addressLine1,
      addressLine2,
      city,
      postalCode,
      country,
      registrationNumber,
    },
    refetchQueries: [
      GET_STAFF,
    ],
  });
}

export const UPDATE_STAFF = gql`
  ${STAFF_DETAIL_FIELDS}
  mutation UpdateStaff(
  $staffId: ID!
  $salary: Float
  $phone1: String
  $phone2: String
  $addressId: ID
  $addressLine1: String
  $addressLine2: String
  $city: String
  $postalCode: String
  $country: String
  $managerId: ID
  ) {
    updateStaff(
    staffId: $staffId
    salary: $salary
    phone1: $phone1
    phone2: $phone2
    addressId: $addressId
    addressLine1: $addressLine1
    addressLine2: $addressLine2
    city: $city
    postalCode: $postalCode
    country: $country
    managerId: $managerId
    ) {
      ...StaffDetailFields
    }
  }
`;

export function updateStaff({
  client,
  addressId,
  addressLine1,
  addressLine2,
  city,
  country,
  managerId,
  phone1,
  phone2,
  postalCode,
  salary,
  staffId,
}: UpdateStaffProps) {
  return client?.mutate<{ updateStaff: StaffType }>({
    mutation: UPDATE_STAFF,
    variables: {
      addressId,
      addressLine1,
      addressLine2,
      city,
      country,
      managerId,
      phone1,
      phone2,
      postalCode,
      salary,
      staffId,
    },
  });
}

export const TERMINATE_STAFF = gql`
  ${STAFF_DETAIL_FIELDS}
  mutation TerminateStaff($staffId: ID!) {
    terminateStaff(staffId: $staffId) {
      ...StaffDetailFields
    }
  }
`;

export function terminateStaff({ client, staffId }: TerminateStaffProps) {
  return client?.mutate<{ terminateStaff: StaffType }>({
    mutation: TERMINATE_STAFF,
    variables: {
      staffId,
    },
  });
}

export const REMOVE_MANAGER = gql`
  mutation RemoveManager(
  $departmentId:ID!
  $headOfDepartmentId: ID!
  ){
    removeManager(
    headOfDepartmentId:$headOfDepartmentId,
    departmentId: $departmentId
    )
  }
`;

export function removeManager({
  client,
  headOfDepartmentId,
  departmentId,
}: RemoveManagerProps) {
  return client?.mutate<{ removeManager: StaffType }>({
    mutation: REMOVE_MANAGER,
    variables: {
      headOfDepartmentId,
      departmentId,
    },
  });
}
